import React, { useEffect, useState } from "react";
import { getStopList, getFolders, getGoods } from "../../utils/dataFetch";
import { SERVER_HOST } from "../../utils/constants";
import ConfirmModal from "./ConfirmModal";

export default function StopList() {
    const [stopListData, setStopListData] = useState([]);
    const [dataError, setDataError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showAddProducts, setShowAddProducts] = useState(false);
    const [showAllRows, setShowAllRows] = useState(false);

    const fetchData = async () => {
        try {
            const stopListResult = await getStopList();
            setStopListData(stopListResult);
        } catch {
            setDataError("Помилка завантаження даних!");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const handleConfirm = () => {
        modalConfig.onConfirm();
        setShowModal(false);
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    const updateStopList = async (actionType, payload) => {
        try {
            const response = await fetch(SERVER_HOST, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage(`Операція успішна!`);
                setTimeout(() => {
                    setSuccessMessage("");
                }, 5000);
            } else {
                setErrorMessage(`Сталася помилка при ${actionType} товару!`);
                setTimeout(() => {
                    setErrorMessage("");
                }, 5000);
            }
        } catch {
            setErrorMessage(`Сталася помилка при ${actionType} товару!`);
            setTimeout(() => {
                setErrorMessage("");
            }, 5000);
        }

        fetchData();
    };

    const addToStopList = (goodId) => {
        setModalConfig({
            message: "Ви впевнені, що хочете додати цей товар до стоп-листа?",
            onConfirm: () =>
                updateStopList("додаванні", {
                    action: "add_stop_list_item",
                    good_id: goodId,
                }),
        });
        setShowModal(true);
    };

    const deleteStopListItem = (stopListItemId) => {
        setModalConfig({
            message:
                "Ви впевнені, що хочете видалити цей елемент зі стоп-листа?",
            onConfirm: () =>
                updateStopList("видаленні", {
                    action: "delete_stop_list_item",
                    stop_list_id: stopListItemId,
                }),
        });
        setShowModal(true);
    };

    const handleShowMoreToggle = () => {
        setShowAllRows((prevShowAllRows) => !prevShowAllRows);
    };

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                {successMessage && (
                    <div className="alert alert-success alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {successMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setSuccessMessage("")}
                        ></button>
                    </div>
                )}
                {errorMessage && (
                    <div className="alert alert-danger alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {errorMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setErrorMessage("")}
                        ></button>
                    </div>
                )}
                <h5 className="text-center fw-bold">Стоп-лист</h5>
                {dataError && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {dataError}
                    </div>
                )}
                {!dataError && (
                    <>
                        {stopListData.length === 0 ? (
                            <h5 className="text-center fw-bold text-muted">
                                Пусто
                            </h5>
                        ) : (
                            <div className="table-responsive rounded-4">
                                <table className="table table-sm table-striped table-light table-hover m-0">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th
                                                className="text-center align-middle"
                                                scope="col"
                                            >
                                                Назва
                                            </th>
                                            <th
                                                className="text-center align-middle"
                                                scope="col"
                                            >
                                                Внесено
                                            </th>
                                            <th
                                                className="text-center align-middle"
                                                scope="col"
                                            >
                                                Автор
                                            </th>
                                            <th
                                                className="text-center align-middle"
                                                scope="col"
                                            >
                                                Дії
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stopListData
                                            .slice(
                                                0,
                                                showAllRows
                                                    ? stopListData.length
                                                    : 5
                                            )
                                            .map((item) => (
                                                <tr key={item.id}>
                                                    <th
                                                        className="text-center align-middle"
                                                        scope="row"
                                                    >
                                                        {item.product_name}
                                                    </th>
                                                    <td
                                                        className="text-center align-middle"
                                                        style={{
                                                            minWidth: "50px",
                                                        }}
                                                    >
                                                        {`${item.start.slice(
                                                            8,
                                                            10
                                                        )}.${item.start.slice(
                                                            5,
                                                            7
                                                        )} ${item.start.slice(
                                                            11,
                                                            16
                                                        )}`}
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        {item.author_name}
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            className="btn btn-light btn-sm rounded-5 border border-1"
                                                            onClick={() =>
                                                                deleteStopListItem(
                                                                    item.id
                                                                )
                                                            }
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="d-flex justify-content-center mt-3">
                            <button
                                className="me-1 btn btn-sm main--button"
                                onClick={() => setShowAddProducts(true)}
                            >
                                Змінити стоп-лист
                            </button>

                            {stopListData.length > 5 && (
                                <button
                                    className="ms-1 btn btn-sm main--button"
                                    onClick={handleShowMoreToggle}
                                >
                                    {showAllRows
                                        ? "Сховати"
                                        : "Показати більше"}
                                </button>
                            )}
                        </div>

                        {showAddProducts && (
                            <>
                                <div className="modal--backdrop fade show"></div>
                                <div
                                    className="modal show"
                                    style={{ display: "block" }}
                                    tabIndex="-1"
                                >
                                    <div className="modal-dialog">
                                        <div className="modal-content rounded-5">
                                            <div className="modal-header">
                                                <h5 className="modal-title ms-0">
                                                    Категорії товарів
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close me-0"
                                                    onClick={() =>
                                                        setShowAddProducts(
                                                            false
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                            <div className="modal-body">
                                                <ItemsTree
                                                    stopListItems={stopListData}
                                                    onAddToStopList={
                                                        addToStopList
                                                    }
                                                    onDeleteFromStopList={
                                                        deleteStopListItem
                                                    }
                                                />
                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm main--button"
                                                    onClick={() =>
                                                        setShowAddProducts(
                                                            false
                                                        )
                                                    }
                                                >
                                                    Закрити
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {showModal && (
                            <ConfirmModal
                                message={modalConfig.message}
                                onConfirm={handleConfirm}
                                onCancel={handleCancel}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

const ItemsTree = ({
    stopListItems,
    onAddToStopList,
    onDeleteFromStopList,
}) => {
    const [error, setError] = useState("");
    const [folders, setFolders] = useState([]);
    const [products, setProducts] = useState([]);
    const [folderState, setFolderState] = useState({});
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const folderResponse = await getFolders();
                const productResponse = await getGoods();

                const filteredFolders = folderResponse
                    .filter((folder) => folder.marked === 0)
                    .sort((a, b) => a.name.localeCompare(b.name));

                const filteredProducts = productResponse
                    .filter((product) => product.marked === 0)
                    .sort((a, b) => a.name.localeCompare(b.name));

                setFolders(filteredFolders);
                setProducts(filteredProducts);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchData();

        // Dashboard scroll lock when modal window is open
        document.body.classList.add("modal--open");
        return () => {
            document.body.classList.remove("modal--open");
        };
    }, []);

    const toggleFolder = (folderId) => {
        setFolderState((prevState) => ({
            ...prevState,
            [folderId]: !prevState[folderId],
        }));
    };

    const isInStopList = (productId) => {
        return stopListItems.some((item) => item.product_id === productId);
    };

    const getStopListItemId = (productId) => {
        const stopListItem = stopListItems.find(
            (item) => item.product_id === productId
        );
        return stopListItem ? stopListItem.id : null;
    };

    const renderFolders = (parentId) => {
        return folders
            .filter((folder) => folder.parent_id === parentId)
            .map((folder) => (
                <div
                    key={folder.id}
                    className={`folder border rounded-4 p-2 mb-2 ${
                        folderState[folder.id] && "bg-secondary bg-opacity-10"
                    }`}
                >
                    <div
                        className="folder-name"
                        onClick={() => toggleFolder(folder.id)}
                        style={{ cursor: "pointer" }}
                    >
                        <div className={`${folderState[folder.id] && "mb-3"}`}>
                            {folderState[folder.id] ? (
                                <i className="bi bi-folder-minus me-1"></i>
                            ) : (
                                <i className="bi bi-folder-plus me-1"></i>
                            )}{" "}
                            {folder.name}
                        </div>
                    </div>
                    {folderState[folder.id] && (
                        <div
                            className="folder-content"
                            style={{ paddingLeft: "20px" }}
                        >
                            {renderFolders(folder.id)}
                            {renderProducts(folder.id)}
                        </div>
                    )}
                </div>
            ));
    };

    const renderProducts = (parentId) => {
        return products
            .filter((product) => product.parent_id === parentId)
            .map((product) => (
                <div
                    key={product.id}
                    className="product border rounded-4 p-2 mb-2 d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    <div>
                        <i className="bi bi-cart3 me-1"></i> {product.name}
                    </div>

                    {isInStopList(product.id) ? (
                        <button
                            className="btn btn-light btn-sm rounded-5 border border-1"
                            onClick={() => {
                                const stopListItemId = getStopListItemId(
                                    product.id
                                );
                                if (stopListItemId) {
                                    onDeleteFromStopList(stopListItemId);
                                }
                            }}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    ) : (
                        <button
                            className="btn btn-light btn-sm rounded-5 border border-1"
                            onClick={() => onAddToStopList(product.id)}
                        >
                            <i className="bi bi-plus-lg"></i>
                        </button>
                    )}
                </div>
            ));
    };

    const renderSearchResults = () => {
        const filteredProducts = products.filter((product) =>
            product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (filteredProducts.length === 0) {
            return <p>Немає продуктів...</p>;
        }

        return filteredProducts.map((product) => (
            <div
                key={product.id}
                className="product border rounded-4 p-2 mb-2 d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
            >
                <div>
                    <i className="bi bi-cart3 me-1"></i> {product.name}
                </div>
                {isInStopList(product.id) ? (
                    <button
                        className="btn btn-light btn-sm rounded-5 border border-1"
                        onClick={() => {
                            const stopListItemId = getStopListItemId(
                                product.id
                            );
                            if (stopListItemId) {
                                onDeleteFromStopList(stopListItemId); // Видаляємо за stop_list_id
                            }
                        }}
                    >
                        <i className="bi bi-trash"></i>
                    </button>
                ) : (
                    <button
                        className="btn btn-light btn-sm rounded-5 border border-1"
                        onClick={() => onAddToStopList(product.id)}
                    >
                        <i className="bi bi-plus-lg"></i>
                    </button>
                )}
            </div>
        ));
    };

    return (
        <>
            {error && (
                <div className="alert alert-danger m-auto rounded-5">
                    {error}
                </div>
            )}
            {!error && (
                <div className="folder-tree">
                    <input
                        type="text"
                        placeholder="Пошук продуктів..."
                        className="form-control mb-3 rounded-5 border-secondary"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    {searchTerm ? renderSearchResults() : renderFolders(null)}
                </div>
            )}
        </>
    );
};
